import * as React from 'react';
import css from './ExploreSearchInputValue.module.scss';

interface Props extends React.HTMLProps<{}> {
  value: string;
  handleDelete: () => void;
}

class ExploreSearchInputValue extends React.PureComponent<Props> {
  public static defaultProps: Props = {
    value: '',
    handleDelete: () => undefined,
  };

  constructor(props: Props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
  }

  private handleDelete() {
    this.props.handleDelete();
  }

  public render() {
    return (
      <div className={css.ExploreSearchInputValue}>
        <span className={css.ExploreSearchInputValue__Text}>
          {this.props.value}
        </span>
        <svg
          className={css.ExploreSearchInputValue__CloseIcon}
          onClick={this.handleDelete}
        >
          <use xlinkHref="#close" />
        </svg>
      </div>
    );
  }
}

export default ExploreSearchInputValue;
